import type { HousingApplication, Listing } from '../types/housing'

export const listings: Listing[] = [
  {
    id: 'lst-1',
    name: 'Cedarwood Student Residence',
    kind: 'Student residence',
    address: '14 Iwaya Road, Onike',
    neighbourhood: 'Onike',
    campusId: 'campus-akoka',
    minutesToCampus: 9,
    rentPerYear: 740000,
    depositMonths: 2,
    roomType: 'Single ensuite',
    occupants: 1,
    bedsAvailable: 6,
    facilities: [
      'Furnished',
      'Electricity',
      'Running water',
      'Internet',
      'Security',
      'Power backup',
      'Study area',
      'Laundry',
    ],
    rules: ['No subletting', 'Quiet hours 22:00 — 06:00', 'Visitors sign in at reception'],
    availableFrom: '1 September 2026',
    description:
      'Purpose-built residence run by a student housing operator. Rooms are ensuite with a shared study lounge on each floor, 24-hour security and a generator that covers the whole building.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/dfe35b93-ce6e-4726-aa9b-b995431280b7.jpg',
    manager: { name: 'Cedarwood Living', role: 'Housing operator', responseTime: 'Usually replies in 2 hours' },
    verification: 'verified',
    verifiedChecks: ['Owner identity', 'Property documents', 'Address'],
    rating: 4.6,
    reviewCount: 84,
    lat: 6.5085,
    lng: 3.3928,
  },
  {
    id: 'lst-2',
    name: 'Akoka Gardens Hostel',
    kind: 'Hostel',
    address: '7 Akoka Street, Bariga',
    neighbourhood: 'Bariga',
    campusId: 'campus-akoka',
    minutesToCampus: 14,
    rentPerYear: 320000,
    depositMonths: 1,
    roomType: 'Twin share',
    occupants: 2,
    bedsAvailable: 11,
    facilities: ['Electricity', 'Running water', 'Security', 'Kitchen', 'Parking'],
    rules: ['No overnight guests', 'Cooking in shared kitchen only'],
    availableFrom: '15 August 2026',
    description:
      'Long-running private hostel a short walk from the back gate. Twin rooms with a shared kitchen per floor and a caretaker on site.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/e9e43371-cec2-4408-9620-c0b4bdd8402b.jpg',
    manager: { name: 'Mr. Sunday Adeniran', role: 'Property owner', responseTime: 'Usually replies same day' },
    verification: 'verified',
    verifiedChecks: ['Owner identity', 'Address'],
    rating: 3.9,
    reviewCount: 132,
    lat: 6.5241,
    lng: 3.3936,
  },
  {
    id: 'lst-3',
    name: 'Yaba Loft — shared 3 bedroom',
    kind: 'Shared apartment',
    address: '22 Herbert Macaulay Way, Yaba',
    neighbourhood: 'Yaba',
    campusId: 'campus-akoka',
    minutesToCampus: 22,
    rentPerYear: 560000,
    depositMonths: 2,
    roomType: 'Private room in shared flat',
    occupants: 3,
    bedsAvailable: 1,
    facilities: ['Furnished', 'Electricity', 'Running water', 'Internet', 'Kitchen', 'Power backup'],
    rules: ['Shared bills split three ways', 'No smoking indoors'],
    availableFrom: '1 October 2026',
    description:
      'One room available in a furnished three bedroom flat currently shared by two final-year students. Bills are split monthly and the flat has an inverter for study hours.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d4c6d8bb-b4e4-4a24-a8b8-597618751d4d.jpg',
    manager: { name: 'Lagos Rooms Agency', role: 'Letting agent', responseTime: 'Usually replies in 1 day' },
    verification: 'pending',
    verifiedChecks: [],
    rating: 4.1,
    reviewCount: 17,
    lat: 6.5057,
    lng: 3.3752,
  },
  {
    id: 'lst-4',
    name: 'Onike Self-Contained Studios',
    kind: 'Self-contained',
    address: '5 Onike Crescent, Onike',
    neighbourhood: 'Onike',
    campusId: 'campus-akoka',
    minutesToCampus: 11,
    rentPerYear: 480000,
    depositMonths: 2,
    roomType: 'Studio',
    occupants: 1,
    bedsAvailable: 3,
    facilities: ['Electricity', 'Running water', 'Kitchen', 'Security'],
    rules: ['Rent paid annually in advance', 'No structural changes'],
    availableFrom: '1 September 2026',
    description:
      'Compact self-contained studios with a private bathroom and kitchenette. Suited to students who want to live alone within walking distance of campus.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/717d678f-1a4d-4dbe-9fa6-c419fda8f0f3.jpg',
    manager: { name: 'Mrs. Grace Nwachukwu', role: 'Property owner', responseTime: 'Usually replies in 3 hours' },
    verification: 'verified',
    verifiedChecks: ['Owner identity', 'Property documents', 'Address'],
    rating: 4.3,
    reviewCount: 41,
    lat: 6.5109,
    lng: 3.3874,
  },
  {
    id: 'lst-5',
    name: 'The Study House Co-living',
    kind: 'Co-living',
    address: '9 Commercial Avenue, Sabo',
    neighbourhood: 'Sabo',
    campusId: 'campus-akoka',
    minutesToCampus: 19,
    rentPerYear: 880000,
    depositMonths: 1,
    roomType: 'Private room, shared commons',
    occupants: 1,
    bedsAvailable: 4,
    facilities: [
      'Furnished',
      'Electricity',
      'Running water',
      'Internet',
      'Security',
      'Power backup',
      'Study area',
      'Laundry',
      'Kitchen',
    ],
    rules: ['Community guidelines apply', 'Cleaning included weekly'],
    availableFrom: '20 August 2026',
    description:
      'Co-living house with private rooms, a large shared study room and weekly cleaning. Rent is inclusive of internet, power and water.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/8682249f-035f-4666-be50-2c03efe5df4a.jpg',
    manager: { name: 'Study House Operators', role: 'Housing operator', responseTime: 'Usually replies in 1 hour' },
    verification: 'verified',
    verifiedChecks: ['Owner identity', 'Property documents', 'Address'],
    rating: 4.8,
    reviewCount: 29,
    lat: 6.5048,
    lng: 3.3819,
  },
  {
    id: 'lst-6',
    name: 'Bariga Twin Rooms',
    kind: 'Hostel',
    address: '31 Ilaje Road, Bariga',
    neighbourhood: 'Bariga',
    campusId: 'campus-akoka',
    minutesToCampus: 26,
    rentPerYear: 260000,
    depositMonths: 1,
    roomType: 'Twin share',
    occupants: 2,
    bedsAvailable: 8,
    facilities: ['Electricity', 'Running water'],
    rules: ['No pets', 'Gate closes 23:00'],
    availableFrom: '1 September 2026',
    description:
      'Budget twin rooms in a residential compound. Power is on the public supply with no backup, and water is from a compound borehole.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bc9b2f01-f101-46e9-833b-b28217344ea7.jpg',
    manager: { name: 'Listed by Emeka A.', role: 'Agent', responseTime: 'Response time unknown' },
    verification: 'unverified',
    verifiedChecks: [],
    rating: 3.2,
    reviewCount: 6,
    lat: 6.5312,
    lng: 3.3891,
  },
  {
    id: 'lst-7',
    name: 'Iwaya Gated Annex',
    kind: 'Apartment',
    address: '18 Iwaya Road, Iwaya',
    neighbourhood: 'Iwaya',
    campusId: 'campus-akoka',
    minutesToCampus: 16,
    rentPerYear: 650000,
    depositMonths: 2,
    roomType: 'One bedroom flat',
    occupants: 1,
    bedsAvailable: 2,
    facilities: ['Electricity', 'Running water', 'Security', 'Parking', 'Kitchen', 'Power backup'],
    rules: ['One occupant per flat', 'Annual rent'],
    availableFrom: '1 November 2026',
    description:
      'Small gated annex of one-bedroom flats behind a private compound, with a shared water tank and a compound generator.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/de93f7d3-66f0-42a2-9977-7935822a4fe4.jpg',
    manager: { name: 'Iwaya Property Managers', role: 'Property manager', responseTime: 'Usually replies in 5 hours' },
    verification: 'pending',
    verifiedChecks: [],
    rating: 4.0,
    reviewCount: 12,
    lat: 6.5024,
    lng: 3.3961,
  },
  {
    id: 'lst-8',
    name: 'Fadeyi Ensuite Rooms',
    kind: 'Student residence',
    address: '3 Ojuelegba Road, Fadeyi',
    neighbourhood: 'Fadeyi',
    campusId: 'campus-akoka',
    minutesToCampus: 34,
    rentPerYear: 420000,
    depositMonths: 1,
    roomType: 'Single ensuite',
    occupants: 1,
    bedsAvailable: 5,
    facilities: ['Furnished', 'Electricity', 'Running water', 'Security', 'Laundry'],
    rules: ['No loud music after 22:00'],
    availableFrom: '10 September 2026',
    description:
      'Ensuite rooms in a converted residential block. Further from campus but on a direct bus route to the main gate.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a2e42834-bc85-4d9d-bac6-5c79353fd98f.jpg',
    manager: { name: 'Fadeyi Living Ltd', role: 'Property manager', responseTime: 'Usually replies in 1 day' },
    verification: 'verified',
    verifiedChecks: ['Owner identity', 'Address'],
    rating: 4.2,
    reviewCount: 55,
    lat: 6.5225,
    lng: 3.3646,
  },
]

export const myApplications: HousingApplication[] = [
  {
    id: 'app-1',
    listingId: 'lst-1',
    listingName: 'Cedarwood Student Residence',
    submitted: '9 Aug 2026',
    moveIn: '1 September 2026',
    status: 'in_review',
    amountDue: 0,
  },
  {
    id: 'app-2',
    listingId: 'lst-4',
    listingName: 'Onike Self-Contained Studios',
    submitted: '5 Aug 2026',
    moveIn: '1 September 2026',
    status: 'submitted',
    amountDue: 0,
  },
]

export function listingById(id: string) {
  return listings.find((listing) => listing.id === id)
}
